// @ts-check
import { gql, useLazyQuery } from '@apollo/client';
import React from 'react';
const EMPTY = '(empty)';

export default function useCompaniesSearch({
  searchTerm = '',
  country,
  companyType,
}) {
  const [fetchCompanies, { data, loading }] = useLazyQuery(query, {
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      fetchCompanies({
        variables: {
          searchTerm,
          country: country === EMPTY ? null : { eq: country },
          companyType,
        },
      });
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchTerm, country, fetchCompanies]);

  return { companies: data?.companies?.nodes || [], loading };
}

const query = gql`
  query searchCompanies(
    $searchTerm: String!
    $country: StringQueryOperatorInput
    $companyType: CompanyType
  ) {
    companies(
      filter: {
        searchTerm: $searchTerm
        country: $country
        companyType: $companyType
      }
    ) {
      totalCount
      nodes {
        brandId
        ... on Producer {
          producerId
        }
        name
        email
        street
        city
        postalCode
        country
        logo {
          fixed(height: 80, width: 80, crop: PAD, fetch_format: AUTO) {
            src
            srcSet
          }
        }
      }
    }
  }
`;
